import React from "react";
import { Grid, TextField, Typography } from "@mui/material";
import ModalLayout from "components/ModalLayout";
import MDButton from "components/MDButton";
import CancelButton from "components/CancelButton";

function ServiceFormModal({
  open,
  isEditing,
  formData,
  onClose,
  onChange,
  onSubmit,
}) {
  return (
    <ModalLayout
      open={open}
      onClose={onClose}
      title={isEditing ? "Update Service Area" : "Create Service Area"}
      subtitle="Service Area"
      maxWidth={700}
      headerContent={
        <Typography variant="body2" color="text.secondary" mt={1}>
          Define the service city and polygon coordinates. Coordinates should be provided as an array
          of lng/lat pairs.
        </Typography>
      }
      actions={
        <>
          <CancelButton onClick={onClose} />
          <MDButton
            type="submit"
            form="service-area-form"
            variant="gradient"
            color="info"
            sx={{ minWidth: 140 }}
          >
            {isEditing ? "Update" : "Create"}
          </MDButton>
        </>
      }
    >
      <form id="service-area-form" onSubmit={onSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="City"
              name="city"
              value={formData.city}
              onChange={onChange}
              required
              InputProps={{ sx: { borderRadius: 2 } }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Coordinates (lng, lat)"
              name="coordinates"
              value={formData.coordinates}
              onChange={onChange}
              multiline
              rows={4}
              placeholder='e.g. [[51.5000, 25.3000], [51.5200, 25.3000], ...]'
              helperText='Enter coordinates as array of arrays. Polygon type is static as "Polygon".'
              required
              InputProps={{ sx: { borderRadius: 2 } }}
            />
          </Grid>
        </Grid>
      </form>
    </ModalLayout>
  );
}

export default ServiceFormModal;
